<template>
<!-- top navigation -->
<div class="top_nav">
  <div class="nav_menu">
    <nav role="navigation">
      <div class="nav toggle">
        <a 
          v-on:click.prevent="toggleSidebar()"
          id="menu_toggle"
        >
          <i class="fa fa-bars"></i>
        </a>
      </div>
      <ul class="nav navbar-nav navbar-right">
        <UserPanel></UserPanel>
      </ul>
    </nav>
  </div>
</div>
<!-- /top navigation -->

</template>

<script>
import UserPanel from '@/components/UserPanel'
export default {
  name: 'topmenu',
  components: {
    UserPanel
  },
  methods: {
    toggleSidebar () {
      this.$emit('toggleSidebar')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Topmenu.vue?888abe96